module.exports = __webpack_public_path__ + "img/Xray-Icon.2bdb3b5d.png";